import React, { memo, useState } from 'react'
import { Link } from 'react-router-dom';
import ChatSupport from '../LandingPage/SmartScheduler/ChatSupport';
import './FloatingChat.css';
import { getUserSelector } from '../../../redux/reducers/reducerSlices/UserReducer';
import { useSelector } from 'react-redux';

const FloatingChat = () => {
    const user = useSelector(getUserSelector);
    const { userType } = user;
  const [active, setActive] = useState(false);
  return (
    <>
      <div className="floating-navigation">
        {/* <Link
          className="nav-link text-center"
          aria-current="page"
          to={"/livechat"}
        > */}
        <div
          className="cursor-pointer"
          onClick={() => {
            setActive(!active);
            // navigate("/livechat");
          }}
        >
          <i className="fa-solid fa-robot"></i>
        </div>
        {/* </Link> */}
      </div>
      {active ? (
        <div className="mobile-chat-window">
          <div
            className={
              userType && userType?.toUpperCase() === "CARRIER"
                ? "mobile-chat-header-new "
                : "mobile-chat-header"
            }
          >
            <div className="mobile-chat-header-text"></div>
            <div
              className="mobile-chat-close cursor-pointer"
              onClick={() => setActive(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <ChatSupport />
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default memo(FloatingChat)